import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1b7c350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cus-permission-denied" }

import { usePermissions } from '@/hooks/usePermissions';
import {
  PermissionDeniedProps,
  PermissionDeniedPropsVariant,
} from '@/rex-components/PermissionDenied/PermissionDenied.type';
import PermissionDenied from '@/rex-components/PermissionDenied/PermissionDenied.vue';
import { useDispatch } from '@/utils/useMappers';
import { computed } from 'vue';
import { HOME_RESOURCE_GROUP } from '@/router/constant';

interface PermissionDeniedWidgetProps extends PermissionDeniedProps {
  chartConfig: Record<string, any>;
  draggable: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionDeniedWidget',
  props: {
    chartConfig: {},
    draggable: { type: Boolean, default: false },
    showTitle: { type: Boolean, default: true },
    showSubTitle: { type: Boolean, default: true },
    variant: { default: PermissionDeniedPropsVariant.SOLID },
    noIcon: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const [setdeleteWidgetId] = useDispatch(['homeState/setdeleteWidgetId']);
const { hasCapabilityWritePermission } = usePermissions();

const hasHomeWritePermission = computed(() => {
  return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
});

return (_ctx: any,_cache: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (!props.chartConfig.accessible)
    ? (_openBlock(), _createBlock(PermissionDenied, {
        key: 0,
        showTitle: props.showTitle,
        showSubTitle: props.showSubTitle,
        variant: props.variant,
        noIcon: props.noIcon
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (hasHomeWritePermission.value && _ctx.draggable)
              ? (_openBlock(), _createBlock(_component_BaseIcon, {
                  key: 0,
                  name: "dragNDrop",
                  width: "0.813rem",
                  height: "1.25rem",
                  class: "cus-home-drag-n-drop-pointer"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.chartConfig.widgetName) + " ", 1),
            (hasHomeWritePermission.value)
              ? (_openBlock(), _createBlock(_component_BaseIcon, {
                  key: 1,
                  name: "deleteFilled",
                  width: ".9125rem",
                  height: ".9125rem",
                  onClick: _cache[0] || (_cache[0] = () => _unref(setdeleteWidgetId)(_ctx.chartConfig.id)),
                  class: "cus-delete-icon"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["showTitle", "showSubTitle", "variant", "noIcon"]))
    : _createCommentVNode("", true)
}
}

})